import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { BroadcastApi, BroadcastRecipientApiClient } from '@sg/api/broadcast-api';

type RecipientTypes =
  | BroadcastApi.DirectEmailRecipient
  | BroadcastApi.DirectFtpRecipient
  | BroadcastApi.ConnectionStringFtpRecipient
  | BroadcastApi.DirectHttpRecipient
  | BroadcastApi.ConnectionStringHttpRecipient;

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    BroadcastRecipient: {
      entity: RecipientTypes;
      query: BroadcastApi.RecipientSearchRequestDto;
    };
  }
}

export class RecipientApiToEntityFetcherLink implements SgEntityFetchAdapter<'BroadcastRecipient'> {
  readonly key: 'BroadcastRecipient' = 'BroadcastRecipient';
  readonly metadata: {
    idField: keyof RecipientTypes;
    labelField: keyof RecipientTypes;
    queryField?: { field: keyof BroadcastApi.RecipientSearchRequestDto; isArray?: boolean };
  } = {
    idField: 'id',
    labelField: 'name',
    queryField: { field: 'name' },
  };

  private readonly recipientsApi: BroadcastRecipientApiClient;

  constructor(injector: Injector) {
    this.recipientsApi = injector.get(BroadcastRecipientApiClient);
  }

  getEntity(id: string) {
    return this.recipientsApi.recipientControllerGetRecipientById(id, { observe: 'body' });
  }

  findEntities(query?: BroadcastApi.RecipientSearchRequestDto, pageNumber?: number) {
    const body: BroadcastApi.RecipientSearchRequestDto = {};

    if (query) {
      const { active: _ignored, ...rest } = query;
      Object.assign(body, rest);
    }
    body.active = true;

    return this.recipientsApi
      .recipientControllerSearchRecipients({ body, pageSize: 10, pageNumber: pageNumber ?? 1 }, { observe: 'body' })
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
